
/**
 * 트윗 유형
 */
export type TrendItemContentTweetsItemBasicInfoAllOfTwoTweetType = typeof TrendItemContentTweetsItemBasicInfoAllOfTwoTweetType[keyof typeof TrendItemContentTweetsItemBasicInfoAllOfTwoTweetType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TrendItemContentTweetsItemBasicInfoAllOfTwoTweetType = {
  ORIGINAL: 'ORIGINAL',
  REPLY: 'REPLY',
  QUOTE: 'QUOTE',
  RETWEET: 'RETWEET',
} as const;
